module.exports = __webpack_public_path__ + "img/gnp_new.fe6a54cf.svg";